<style scoped>
    .demo-drawer-footer{
        width: 400px;
        position: fixed;
        bottom: 0;
        right: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
    .tablelist{
        border: 1px solid #fff;
        border-collapse: collapse;/* 边框重叠 */
        width:100%;
    }
    .tablelist td{
        border:1px solid #fff;
        height:47px;
        line-height: 47px;
        padding-left:10px;
        padding-right:10px;
        text-align: center;
        font-size: 14px;
        cursor:pointer;
        background:#f2f2f2;
        user-select: none;
    }
    .tablelist td:active,.tablelist td:focus{
        background:#fff;
    }
    .colorPannel {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        display:inline-block;
        margin-left:20px;
    }
</style>
<template>
    <div>

        <Form v-if="sbinfo.modeType==0&&sbinfo.status" ref="accountLogin" :model="accountLogin" :rules="ruleValidate">
            <FormItem prop="fenlei">
                <Select v-model="accountLogin.fenlei" label-in-value @on-change="onFlSelect" placeholder="移动此设备至..." style="width:100%">
                    <Option v-for="item in fllist" :value="item.catId" :key="item.catId" >{{ item.catName }}</Option>
                </Select>
            </FormItem>
            <FormItem label="设备名称编辑：" prop="deviceName">
                <Input v-model="accountLogin.deviceName" placeholder="请输入设备名称" style="width: 100%" />
            </FormItem>
        </Form>

        <!--设备状态-->
        <div v-if="sbinfo.modeType==0">
            <Divider>设备状态</Divider>
            <div style="height: 40px">
                <label style="font-size: 13px;text-align: center;">运行状态</label>
                <img src="@/assets/img//ic_broken.png" v-if="!sbinfo.status" style="width:30px;height: 30px;float:right;">
                <img src="@/assets/img//ic_good.png" v-if="sbinfo.status" style="width:30px;height: 30px;float:right;">
            </div>
            <div style="height: 40px">
                <label style="font-size: 13px;text-align: center;">总运行时间</label>
                <label v-model="runTime" style="font-size: 20px;float:right;">{{getHour(sbinfo.totalRunning)}}h</label>
            </div>
            <div style="height: 40px">
                <label style="font-size: 13px;text-align: center;">最近运行时长</label>
                <label v-model="runTime" style="font-size: 20px;float:right;">{{getHour(sbinfo.lastRunning)}}h</label>
            </div>

        </div>

        <!--播放、音量控制-->
        <div v-if="sbinfo.status">
            <Divider>音乐</Divider>
            <span>通道</span>
            <Select v-model="chaText" clearable label-in-value @on-change="onRepeatConfirm" placeholder="请选择通道">
                <Option v-for="item in chaList" :value="item" :key="item">{{ item }}</Option>
            </Select>
            <div style="padding-top: 10px; padding-bottom: 10px">
                <span>音量</span>
                <Slider v-model="volume" :min="0" :max="100" :step="1" show-stops  @on-change="volumeChange">
                </Slider>
            </div>
            <div style="height: 40px;float:right">
                <label style="font-size: 20px;">{{sec_to_time(time_pos)}}/</label>
                <label style="font-size: 20px;">{{sec_to_time(length)}}</label>
            </div>
            <div style="padding-top: 10px; padding-bottom: 10px">
                <Slider v-model="progress" :min="0" :max="100" :step="1" show-stops  @on-change="progressChange">
                </Slider>
            </div>
            <div >
                <img v-if="statu==0" src="@/assets/img//ic_play.png" @click="playOnOut"  style="height: 40px;padding-right: 10px">
                <img v-else src="@/assets/img//ic_out.png" @click="playOnOut"  style="height: 40px;padding-right: 10px">
                <span style="color: black;font-size: 20px">{{filePath}}</span>
            </div>
        </div>
        <Divider >歌曲目录:</Divider>
        <!--目录返回-->
        <div v-if="page>1" >
            <img  style="width: 25px;height: 30px;padding-bottom: 10px" src="@/assets/img//last.png" @click="lastPage">
        </div>
        <div v-if="list.length>0" class="tf-table">
            <div v-for="(item,index) in list" :key="index">
                <li  tapmode="active-style" @click="nextPage(item,index)" style="height: 40px">
                    <span style="color: black;font-size: 15px">{{item}}</span>
                    <img v-if="item.split('.').length==1" src="@/assets/img//ic_right.png" @click="playOnOut"  style="height: 20px;float:right;padding-right: 10px">
                </li>
            </div>


        </div>
        <!--没有目录-->
        <p v-else style="text-align: center; padding: 20px 0; color:#cecece">暂无内容</p>

        <div v-if="sbinfo.modeType==0">
            <Divider >设备详情</Divider>
            <dl  class="tf-cell">
                <dd><span>设备名称：</span>{{sbinfo.deviceName ? sbinfo.deviceName : 'N/A'}}</dd>
                <dd><span>设备类型：</span>{{sbinfo.catName ? sbinfo.catName : 'N/A'}}</dd>
                <dd><span>设备ID：</span>{{sbinfo.deviceId ? sbinfo.deviceId : 'N/A'}}</dd>
            </dl>
        </div>


        <!--按钮-->
        <div v-if="sbinfo.modeType==0&&sbinfo.status" class="demo-drawer-footer">
            <Button style="margin-right: 8px" @click="onCancel">取消</Button>
            <Button style="margin-right: 8px" type="error" @click="onDel">删除设备</Button>
            <Button type="primary" @click="onSubmit">确定</Button>
        </div>
        <div v-if="sbinfo.modeType==1" class="demo-drawer-footer">
            <Button style="margin-right: 8px" @click="onCancel">取消</Button>
            <Button type="primary" @click="onSave">确定</Button>
        </div>
    </div>
</template>

<script>
    import xl from '@/assets/img/lx/xl.png';

    export default {
        props: ['sbinfo'],

        data() {
            return {
                xl:xl,

                src:'',

                fllist:[],

                list: [],

                //定时
                csTime:0,
                runTime: 0,// 连续运行时间
                //设备开关
                issbSwitch:false,

                // 设备详情
                con:'',

                //表单
                accountLogin: {
                    fenlei: '',
                    deviceName:this.sbinfo.deviceName || ''
                },
                ruleValidate: {
                    deviceName: [
                        { required: true, message: '设备名称不能为空', trigger: 'blur' }
                    ],
                },
                path:'',
                list:[],
                dataList:[],
                page:0,
                statu:0,
                filePath:'未选择歌曲',
                volume:20,
                length:100,
                time_pos:0,
                progress:0,
                chaPopShow:false,
                chaText:'定阻定压',
                chaList:['定阻','定压','定阻定压'],
                cha:2,
            };
        },
        computed: {

        },
        watch:{

        },
        created(){
            var that = this;
            if (that.sbinfo.modeType == 1) {
                that.statu=1;//场景中默认开启
            }else {//设备列表0，大屏2
                that.getCategory();
                that.getInfo();
            }
            that.getSDList('',0);
//            that.page=1;
//            that.list=['你好','wo.mp4','一壶','1234'];
//            that.dataList.push({page: that.page,index:0, data: that.list});
            console.log('数据'+JSON.stringify(that.sbinfo.modeType));
            console.log(that.sbinfo.factoryType);
            console.log(that.sbinfo.status);
            console.log(that.sbinfo.netMac);
            console.log(that.sbinfo.eid);
            console.log(that.sbinfo.eqmsg);

        },
        methods: {
            getHour(sec) {
                if (sec <=0) return 0;
                return (sec / 60 / 60).toFixed(2); // 保留两位小数

            },
            //分类移动
            onFlSelect(val){
                const that = this;
                that.$func.ajax('customerDeviceCatUpdate',{
                    catId:val.value,
                    custDeviceId:that.sbinfo.deviceId,
                    token:that.$func.getToken()
                },function(r){
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.$func.msg('移动成功');
                        that.getInfo();
                        that.$emit("refresh");
                    }
                })
            },
            getCategory(){
                const that = this;
                that.$func.ajax('catList',{
                    catPosition:3,
                    token:that.$func.getToken()
                },function(r){
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        console.log(r.type);
                        that.fllist = r.type;
                    }
                })
            },
            getInfo(){
                const that = this;
                that.$func.ajax('refreshInfo', {
                    token: that.$func.getToken(),
                    deviceNo: that.sbinfo.deviceId
                }, function (r) {
                    if (r.statusCode) {//成功
                        console.log('查询来了');
                        that.statu= r.type.statu;
                        if(that.statu&&r.type.filePath){
                            that.filePath= r.type.filePath;
                        }
                        if(that.statu&&r.type.time_pos){
                            that.time_pos=r.type.time_pos;
                        }
                        if(that.statu&&r.type.length){
                            that.length= r.type.length;
                        }
                        that.progress=that.time_pos/that.length*100;
                        that.volume= r.type.volumn;

                    } else {//离线
                        that.$func.msg(r.message);
                    }
                }, function (err) {
                    that.$func.msg(err)
                })
                setInterval(function () {
                    console.log('数据'+that.statu+'#'+that.progress);
                    if(that.statu==1&&that.progress<100){
                        that.time_pos+=1;
                        that.progress=that.time_pos/that.length*100;
                        console.log('数据'+that.time_pos+'$'+that.progress);
                    }else if(!that.progress<100){
                        that.statu=0;
                    }
                }, 1000)
            },
            getSDList(path,index){
                var that=this;
                that.$func.ajax('listSD', {
                    gatewayId: that.sbinfo.netMac,
                    path:path
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                        var paths=''
                        var strs=that.path.split('/');
                        for (var i=0;i<that.page-1 ;i++ )
                        {
                            paths+=strs[i]+'/';
                        }
                        that.path=paths;
                    } else {
                        that.page++;
                        that.list=r.type.result;
                        that.dataList.push({page: that.page,index:index, data: that.list});
                        console.log('数据'+JSON.stringify(that.dataList));
                    }
                })
            },
            playOnOut(){
                var that=this;
                if (that.sbinfo.modeType  == 1) {
                    that.statu=that.statu==0 ? 1:0;
                    return
                }
                //播放、暂停
//                    var command=!that.statu ? 2:3;
                that.playMusic(that.filePath,2);
            },
            //进度条监听
            progressChange(){
                var that=this;
                that.time_pos= that.progress/100*that.length;
                that.playMusic(that.filePath,5);
            },
            //音量监听
            volumeChange(){
                var that=this;
                if (that.sbinfo.modeType  == 1) {
                    return
                }
                that.$func.ajax('setVolume', {
                    gatewayId: that.sbinfo.netMac,
                    volume:that.volume
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {

                    }
                })
            },
            nextPage(item,index){
                var that=this;
                if(item.split('.').length==1){//文件夹
                    that.path=that.path+item+'/';
                    console.log('path='+that.path);
                    that.getSDList(that.path,index);
//                        that.page++;
//                        if(that.page==2){
//                            that.list=['222.mp3','wo.mp4','一壶','1234'];
//                        }else if(that.page==3){
//                            that.list=['333.mp3','你好','小小鸟.mp3','dhfui'];
//                        }
//                        that.dataList.push({page: that.page,index:index, data: that.list});
                        console.log('数据'+JSON.stringify(that.dataList));
                }else {//音乐、播放
                    if (that.sbinfo.modeType  == 1) {
                        that.filePath=item;
                        return
                    }
                    that.filePath=item;
                    that.playMusic(item,4);
                }
            },
            playMusic(item,command){
                var that=this;
                if (that.filePath == '未选择歌曲') {
                    that.$func.msg('请选择歌曲');
                    return
                }
                var path=command==2? '':that.path+item;
                that.$func.ajax('playMusic', {
                    mobileId:that.$func.getToken(),
                    gatewayId: that.sbinfo.netMac,
                    deviceNo: that.sbinfo.deviceId,
                    path:path,
                    cha:that.cha,
                    time:0,
                    command:command,
                    time_pos:that.time_pos
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$func.msg('操作成功');
                        if(command==2){
                            that.statu=!that.statu;
                        }else {
                            that.statu=1;
                        }
                        if(r.type.time_pos){
                            that.time_pos=r.type.time_pos;
                        }
                        if(r.type.length){
                            that.length= r.type.length;
                        }
                        that.filePath=item;
                        if(that.sbinfo.modeType  == 2){
                            that.$emit("updateSong");
                            that.$emit('close');
                        }

                    }
                })
            },
            lastPage(){
                var that=this;
                if(that.page>1){
                    that.list=that.dataList[that.page-2].data;
                    that.page--;
                    that.dataList.pop();
                    if(that.page==1){
                        that.path='';
                    }else{
                        var paths=''
                        var strs=that.path.split('/');
                        for (var i=0;i<that.page-1 ;i++ )
                        {
                            paths+=strs[i]+'/';
                        }
                        that.path=paths;
                    }
                    console.log('path='+that.path);
                    console.log('数据'+JSON.stringify(that.dataList));
                    console.log(that.page);
                }
            },
            onRepeatConfirm(val){
                var that = this;
                console.log(val);
                that.chaText=val.value;
                that.chaList.map(function(item,index){
                    if(item == val.value){
                        that.cha=index;
                    }
                })
                console.log(that.cha);
            },
            onDel(){
                const that = this;
                that.$Modal.confirm({
                    title: '确定删除设备吗？',
                    content: '设备删除后无法回撤，请您知晓！',
                    onOk: () => {
                        that.$func.ajax('customerDeviceDel',{
                            deviceNo:that.sbinfo.deviceId,
                            token:that.$func.getToken()
                        },function(r){
                            if(!r.statusCode){
                                that.$func.msg(r.message,'error');
                            }else{
                                that.$emit("refresh");
                                that.$func.msg('删除成功');
                                that.onCancel();
                            }
                        })
                    }
                });
            },
            onCancel(){
                this.src = "";
                this.$emit('close');
            },
            //场景中设置保存
            onSave(){
                const that = this;
                that.src = "";
                var status=that.statu+3;//3停止、4指定歌曲播放
                if(that.statu==1&&that.filePath=='未选择歌曲'){
                    func.msg('未选择歌曲,当前状态不能为播放');
                }else{
                    that.$emit('close',status,that.volume,that.path+that.filePath,that.cha,that.sbinfo.index,that.sbinfo.index2,that.sbinfo.i);
                }

            },
            onSubmit(){
                const that = this;
                //验证表单
                that.$refs['accountLogin'].validate(valid => {
                    if (valid)
                    {
                        that.$func.ajax('customerDeviceNameUpdate',
                        {
                            token:that.$func.getToken(),
                            custDeviceId:that.sbinfo.deviceId,
                            deviceName:that.accountLogin.deviceName
                        },function(r){
                            if(!r.statusCode){
                                that.$func.msg(r.message,'error');
                            }else{
                                that.$emit("refresh");
                                that.$func.msg('修改成功！');
                                that.onCancel();
                            }
                        })
                    }
                });
            },
    /**
     * 时间秒数格式化
     * @param s 时间戳（单位：秒）
     * @returns {*} 格式化后的时分秒
     */
    sec_to_time(s) {
        var t='';
        if(s > -1){
            var hour = Math.floor(s/3600);
            var min = Math.floor(s/60) % 60;
            var sec = s % 60;
            if(hour>0&&hour < 10) {
                t = '0'+ hour + ":";
            } else if(hour>10) {
                t = hour + ":";
            }

            if(min < 10){t += "0";}
            t += min + ":";
            if(sec < 10){t += "0";}
            t += sec.toFixed(0);
        }
        return t;
    }
        },
        mounted()
        {

        },
        //离开当前页面后执行
//        destroyed: function () {
//            this.$emit("refresh");
//        },
    };
</script>